module.exports = __webpack_public_path__ + "static/media/JS Cheats.e3eb15cc.jpg";